import React from 'react';
import ResortPassHint from '#modules/profileSelection/profilelist/ResortPassHint';
import useTranslation from 'next-translate/useTranslation';
import useResortPass from '#hooks/useResortPass';

/* @see VOD-1502, VOD-2276
const EXPIRY_WARNING_TIME = 30;

function getDaysLeft(date: string): number {
  const targetDate = new Date(date).getTime();
  const today = Date.now();
  const timeLeft = targetDate - today;
  return Math.ceil(timeLeft / 1000 / 60 / 60 / 24);
}

function getRemainingDays(resortPass): number {
  if (resortPass) {
    const daysLeft = getDaysLeft(resortPass.expirationDate);
    if (daysLeft <= EXPIRY_WARNING_TIME) {
      return daysLeft;
    }
  }
  return 365;
}
*/

const ResortPassInfo = () => {
  const { t } = useTranslation();
  // @see VOD-1502, VOD-2276
  // const remainingDays = getRemainingDays(extra?.resortPass);

  const { hasResortPass } = useResortPass();

  return (
    <div className="tw-text-center tw-mt-6">
      {hasResortPass && (
        <ResortPassHint text={t('profileSelectionResortPassHint')} />
      )}
      {/* @see VOD-1502, VOD-2276 */}
      {/*hasResortPass && remainingDays < EXPIRY_WARNING_TIME && (
        <Typography
          fontSize="small"
          dangerouslySetInnerHTML={{
            __html: t('profileSelectionResortPassExpirationWarning', {
              days: remainingDays,
              count: Math.max(0, remainingDays),
            }),
          }}
        />
      )}
      {hasResortPass && remainingDays <= 0 && (
        <Typography
          fontSize="small"
          dangerouslySetInnerHTML={{
            __html: t('profileSelectionResortPassExpired'),
          }}
        />
      )*/}

      {!hasResortPass && (
        <ResortPassHint text={t('profileSelectionNoResortPassHint')} />
      )}
    </div>
  );
};

export default ResortPassInfo;
